'use strict';
/*
    Creates a dropdown menu of options for an input field.
    Header items must contain a truthy `header` property (will not be selectable).
*/
namespace Autocompleter {

    interface ISelected {
        item: IData;
        e: JQueryEventObject;
    }

    interface IData {
        header: string;
    }

    class FieldOptions2 {

        private inputEl: JQuery;
        private data: any[];
        private select: (ISelected) => void;
        private headerFormat: string;
        private optionFormat: string;
        private formatHeader: ng.ICompiledExpression;
        private formatLabel: ng.ICompiledExpression;
        private ul: JQuery;
        private selOptionClass: string = 'selected';

        uiState = {
            menuPopulated: false,
            denyScroll: false,
            selectedIndex: -1,
            selectableOptions: {},
            selectableOpsCount: 0,
        };

        constructor(
            private $scope: any,
            private $element: JQuery,
            private $timeout: ng.ITimeoutService,
            private $q: ng.IQService,
            $parse: ng.IParseService
        ) {
            this.formatHeader = $parse(this.headerFormat || 'Title');
            this.formatLabel = $parse(this.optionFormat || 'Title');
            this.ul = $element;
        }

        createMenu(): void {

            let eventNS: string = '.fieldOptions';

            let uiHandlers = {
                9: () => this.selectCurrentOption(), // Tab
                13: () => this.selectCurrentOption(), // Return
                16: angular.noop, // Shift
                38: () => this.traverseOptions(-1), // Up arrow
                40: () => this.traverseOptions(1) // Down arrow
            };

            // Debounced menu refresh (thenable)
            const debouncedPopulateMenu = _.debounce(resolve => {
                this.populateMenu(this.data);
                resolve();
            }, 100, {
              'leading': true,
              'trailing': true
            });
            const refreshMenu = () => this.$q(debouncedPopulateMenu);

            this.$scope.$watch('fo.data', v => {
                if (v) {
                    refreshMenu();
                }
            });

            // DOM listeners on input field
            this.inputEl
                .on('focus' + eventNS, refreshMenu)
                .on('keydown' + eventNS, function(event: JQueryEventObject) {
                    let handler = uiHandlers[event.keyCode];
                    handler ? handler() : refreshMenu();
                })
                .on('click' + eventNS, function() {
                    this.setSelectionRange(0, this.value.length);
                    refreshMenu();
                });

            // DOM listeners on menu ul
            this.ul
                .on('mouseleave' + eventNS, () => this.clearHighlight())
                .on('mouseenter' + eventNS, '> li', (event: JQueryEventObject) => {
                    const index = this.ul.find('.field-options-item').index(event.target);
                    if (index > -1) {
                        this.highlightOption(index);
                    } else {
                        this.clearHighlight();
                    }
                });

            this.$scope.$on('$destroy', () => {
                this.inputEl.off(eventNS);
                this.ul.off(eventNS);
            });
        }

        getCurrentOption() {
            if (this.uiState.selectedIndex > -1) {
                return this.$element.find('li').eq(
                    this.uiState.selectableOptions[this.uiState.selectedIndex].domIndex
                );
            }
        }

        selectCurrentOption() {
            let op = this.getCurrentOption();
            if (op) {
                op.trigger('click');
            }
        }

        selectItem(params: ISelected) {
            let item = params.item;
            if (params.e) {
                params.e.preventDefault();
                params.e.stopPropagation();
            }
            if (item && !item.header) {
                this.$scope.$emit('fieldOptionSelected', item);
                this.$timeout(() => {
                    this.select(params); // `select` attribute
                });
            }
        }

        clearMenu() {
            this.uiState.selectableOptions = {};
            this.uiState.selectableOpsCount = 0;
            this.uiState.menuPopulated = false;
            this.ul.empty();
        }

        populateMenu(data: any[]) {
            this.clearMenu();

            if (data) {
                let opsCount = 0;
                data.forEach((o, i) => {
                    $(`<li class="${this.getItemClasses(o)}">
                          ${this.getLabelHTML(o)}
                       </li>`)
                        .click(e => this.selectItem({item:o, e:e}))
                        .appendTo(this.ul);

                    // Index non-headers
                    if (!o.header) {
                        this.uiState.selectableOptions[opsCount++] = {domIndex: i, item: o};
                    }
                });
                this.uiState.selectableOpsCount = opsCount;

                if (opsCount) {
                    this.selectNone();
                    this.uiState.menuPopulated = true;
                    this.scrollToMenu();
                } else {
                    this.clearMenu();
                }
            }
        }

        scrollToMenu() {
            this.$timeout(() => {
                if (!this.uiState.denyScroll && this.ul.is(':visible')) {
                    let winPos = $(window).scrollTop(),
                        winHeight = $(window).height(),
                        ulPos = this.ul.offset().top,
                        ulHeight = this.ul.outerHeight(),
                        ulBottom = ulPos - winPos + ulHeight + 10, // Arbitrary gap
                        scrollPos = winPos + Math.min(ulBottom - winHeight, 150);

                    if (scrollPos > 0) {
                        this.uiState.denyScroll = true;
                        $('html, body').animate({scrollTop: scrollPos}, 200);
                    }
                }
            });
        }

        getLabelHTML(item: any) {
            if (item.header) {
                return this.formatHeader(item);
            }
            let label = this.formatLabel(item),
                fieldVal = this.inputEl.val(),
                term = fieldVal && fieldVal.trim().toLowerCase();
            if (term) {
                let termPos = label.toLowerCase().indexOf(term);
                if (termPos > -1) {
                    let termEnd = termPos + term.length,
                        [str0, str1, str2] = [
                            label.substring(0, termPos),
                            label.substring(termPos, termEnd),
                            label.substring(termEnd)
                        ];
                    label = `${str0}<span class="field-options-highlight">${str1}</span>${str2}`;
                }
            }
            let icon = '';
            if (item.icon) {
                //const cssClass = item.isChild ? 'field-options-child' : '';
                //icon = `<i class="icon-${item.icon} ${cssClass}"></i>`;
                //icon = `<i class="icon icon-${item.icon}"></i>`;
            }
            label = `${icon} ${label}`;
            return label;
        }

        highlightOption(i: number) {
            this.clearHighlight();
            this.uiState.selectedIndex = this.loopIndex(i, 0, this.uiState.selectableOpsCount-1);
            const currentOption = this.getCurrentOption();
            if (currentOption) { currentOption.addClass(this.selOptionClass); }
        }

        clearHighlight() {
            this.$element.find('.' + this.selOptionClass).removeClass(this.selOptionClass);
        }

        selectNone() {
            this.uiState.selectedIndex = -1;
            this.clearHighlight();
        }

        traverseOptions(incr: number) {
            let op:any = this.highlightOption(this.uiState.selectedIndex + incr),
                opPos = op.position(),
                opTop = opPos && opPos.top;

            if (opTop) {
                // Center option vertically
                this.ul.scrollTop(
                    this.ul.scrollTop() + opTop - this.ul.height()/2 + op.outerHeight(true)/2
                );
            }
        }

        loopIndex(i: number, start: number, end: number) {
            return i < start ? end : (i > end ? start : i);
        }

        getItemClasses(item) {
            let classes: string[] = [];
            classes.push(item.header ? 'field-options-header' : 'field-options-item');
            if (item.isGroup) {
                classes.push('field-options-item-parent');
            }
            if (item.isChild) {
                classes.push('field-options-item-child');
            }
            return classes.join(' ');
        }
    };

    angular
        .module('core')
        .directive('fieldOptions2', (): ng.IDirective => {
            return {
                restrict: 'E',
                scope: {},
                controller: FieldOptions2,
                controllerAs: 'fo',
                bindToController: {
                    inputField: '&', // JQuery element
                    data: '=', // Array of objects
                    select: '&', // Selection handler fn
                    headerFormat: '@', // Expression for header text format in menu (via $parse)
                    optionFormat: '@' // Expression for option text format in menu (via $parse)
                },
                replace: true,
                template: `<ul ng-class="'field-options ' + classes"
                                ng-show="fo.uiState.menuPopulated"></ul>`,
                link: (scope: any) => {
                    // Initialise once input field exists
                    let unwatchInit = scope.$watch(
                        () => scope.fo.inputField(),
                        (inputEl: JQuery) => {
                            if (inputEl) {
                                unwatchInit();
                                scope.fo.inputEl = inputEl;
                                scope.fo.createMenu();
                            }
                        }
                    );
                }
            };
        });
}
